import { extendObservable, action } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import NotificationService from '../../../core/services/NotificationService';
import { isRequired } from '../../../core/validations';

export default class PlacementTestRulerFormService {
  fetch = new FetchService();
  submit = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      placementTestRulerId: null,
    });
    this.form.validations = {
      name: [isRequired],
      distributor: [isRequired],
    };
  }

  handleLoad = action((placementTestRulerId) => {
    this.form.reset();
    if (placementTestRulerId) {
      this.fetch.fetch({
        url: `/placement-test-rulers/${placementTestRulerId}`,
        apiVersion: 'v3'
      }).then(() => {
        if (this.fetch.data) {
          this.form.setInitialValues(this.fetch.data);
        }
      });
    } else {
      this.form.setInitialValues({});
    }
    this.placementTestRulerId = placementTestRulerId;
  });

  handleSubmit = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      NotificationService.addNotification('Fill the required fields', 'error');
      return;
    }
    const placementTestRulerId = this.form.getValue('id');
    this.submit.fetch({
      method: placementTestRulerId ? 'put' : 'post',
      url: placementTestRulerId ? `/placement-test-rulers/${placementTestRulerId}` : '/placement-test-rulers',
      body: {
        ...this.form.getValues(),
      },
      apiVersion: 'v3'
    }).then(() => {
      if (this.submit.data) {
        const PlacementTestRuler = this.submit.data;
        this.placementTestRulerId = PlacementTestRuler.id;
        this.form.reset();
        this.form.setInitialValues(PlacementTestRuler);

        NotificationService.addNotification(`Placement Test Ruler ${placementTestRulerId ? 'updated' : 'created'} successfully.`, 'success');
      }
      if (this.submit.error) {
        NotificationService.addNotification(`Error ${placementTestRulerId ? 'updating' : 'creating'} placement test ruler.`, 'error');
      }
    });
  });
}
